t = require('views/internal/teacup-with-helpers')('connect_failed')

module.exports = ->
  t.text t.mustacheVar('msg')
  t.br()
  t.a '.app-alert-item-button', { href: '#', onclick: 'window.location.reload()' }, ->
    t.format 'reload-page'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/connect_failed.coffee